import { call, put, takeLatest } from 'redux-saga/effects';
import { loadingRequest, loadingSuccess } from '@stores/global/actions.js';
import { GlobalModal } from '@components/molecules/PopupModal/GlobalModal.jsx';
import { ErrorLevelConfig } from '@core/configureStore/ErrorLevelConfig.js';
import {
  getListOfValuesClaimDocumentService,
  getPhoneService,
  getPOFullNameService,
  getPolicyProvinceListService,
  searchBankEmployeeCodeService,
  searchReferralUnitCodeService,
} from '@services/policy/policy.js';
import {
  GET_BANK_EMPLOYEE_CODE,
  GET_BANK_REFFERER_CODE,
  GET_LIST_OF_VALUES_CLAIM_DOCUMENT,
  GET_PHONE_DATA,
  GET_PO_FULL_NAME_DATA,
  GET_POLICY_PROVINCE,
} from '@stores/policy/constants.js';
import {
  setBankEmployeeCodeRequest,
  setBankReffererCodeRequest,
  setLovClaimDocumentRequest,
  setPolicySearchProvinceRequest,
} from '@stores/policy/actions.js';

// Các mã vùng không phải Tỉnh/Thành phố thực tế, không hiển thị trong dropdown
const EXCLUDED_PROVINCE_CODES = [
  'RB',
  'RC',
  'RD',
  'RN',
  'RE',
  'RH',
  'RA',
  'RF',
  'RM',
  'RI',
  'RL',
  'RO',
  'VN',
  'XX',
];

export function* getPhone({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getPhoneService, payload);
    yield put(loadingSuccess());

    if (callback) callback(response);
  } catch (err) {
    yield put(loadingSuccess());
    if (callback) callback(null);
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getPOFullName({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getPOFullNameService, payload);
    yield put(loadingSuccess());

    if (callback) callback(response);
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getPolicySearchProvinces({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getPolicyProvinceListService);
    yield put(loadingSuccess());

    const filteredProvinces = Array.isArray(response?.data)
      ? response.data.filter(
          (province) =>
            !EXCLUDED_PROVINCE_CODES.includes(province?.mappingProvinceCode),
        )
      : response?.data;

    yield put(
      setPolicySearchProvinceRequest({ ...response, data: filteredProvinces }),
    );
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
  }
}

export function* getLovClaimDocuments({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getListOfValuesClaimDocumentService);
    yield put(loadingSuccess());

    yield put(setLovClaimDocumentRequest(response));
    if (callback) callback(response);
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
  }
}

export function* getBankEmployeeCode({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(searchBankEmployeeCodeService, payload);
    yield put(loadingSuccess());

    yield put(setBankEmployeeCodeRequest(response));

    if (callback) callback(response?.data);
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
  }
}

export function* getBankReffererCode({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(searchReferralUnitCodeService, payload);
    yield put(loadingSuccess());

    yield put(setBankReffererCodeRequest(response));

    if (callback) callback(response?.data);
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
  }
}

export default function* policySaga() {
  yield takeLatest(GET_PHONE_DATA, getPhone);
  yield takeLatest(GET_PO_FULL_NAME_DATA, getPOFullName);
  yield takeLatest(GET_POLICY_PROVINCE, getPolicySearchProvinces);
  yield takeLatest(GET_LIST_OF_VALUES_CLAIM_DOCUMENT, getLovClaimDocuments);
  yield takeLatest(GET_BANK_EMPLOYEE_CODE, getBankEmployeeCode);
  yield takeLatest(GET_BANK_REFFERER_CODE, getBankReffererCode);
}
